import { render, staticRenderFns } from "./PedidoDeCompraConteudo.vue?vue&type=template&id=3efd606c&scoped=true"
import script from "./PedidoDeCompraConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./PedidoDeCompraConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./PedidoDeCompraConteudo.vue?vue&type=style&index=0&id=3efd606c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3efd606c",
  null
  
)

export default component.exports